import React from "react";
import TextField from "./Fields/TextField";
import TextArea from "./Fields/TextArea";
import CheckBox from "./Fields/CheckBox";
import FieldValidation from "./Validation/FieldValidation";
import CurrencyField from "./Fields/CurrencyField";
import PercentField from "./Fields/PercentField";
import DecimalField from "./Fields/DecimalField";
import IntegerField from "./Fields/IntegerField";
import SelectField from "./Fields/SelectField";
import LocationPlaceSelectField from "./Fields/LocationPlaceSelectField";
import { useSelector } from "react-redux";
import DateField from "./Fields/DateField";

const FormField = ({ props }) => {
  const {
    name,
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError,
  } = props;
  const currentUser = useSelector((st) => st.currentUser);
  const isDeveloper = currentUser?.userStatus === "developer";

  const fSettings = fieldSettings[name];

  const handleChange = (e) => {
    setFieldErrors({ ...fieldErrors, [e.target.name]: "" });
    setVariables({ ...variables, [e.target.name]: e.target.value });
    setServerError && serverError && (() => setServerError(""))();
  };

  const validateField = (e) => {
    const { name, value } = e.target;
    const validation = new FieldValidation(
      name,
      value,
      fieldSettings,
      variables
    );
    const objValid = validation.isValid();
    if (objValid.valid) {
      const newFieldErrors = { ...fieldErrors };
      delete newFieldErrors[name];
      setFieldErrors({ ...newFieldErrors });
    } else {
      setFieldErrors({ ...fieldErrors, [name]: objValid.errMsg });
    }
  };

  const newProps = {
    ...props,
    handleChange,
    validateField,
  };
  const { fieldType } = fSettings;

  switch (fieldType) {
    case "text":
      return <TextField key={name} name={name} props={newProps} />;
    case "date":
      return <DateField key={name} name={name} props={newProps} />;
    case "integer":
      return <IntegerField key={name} name={name} props={newProps} />;
    case "locationPlaceSelect":
      return (
        <LocationPlaceSelectField key={name} name={name} props={newProps} />
      );
    case "break":
      return <br />;

    case "select":
      return <SelectField key={name} name={name} props={newProps} />;
    case "textarea":
      return <TextArea key={name} name={name} props={newProps} />;
    case "checkBox":
      return <CheckBox name={name} key={name} props={newProps} />;
    case "boolean":
      return <CheckBox name={name} key={name} props={newProps} />;
    case "decimal":
      return <DecimalField key={name} name={name} props={newProps} />;
    case "percent":
      return <PercentField key={name} name={name} props={newProps} />;
    case "currency":
      return <CurrencyField key={name} name={name} props={newProps} />;
    default:
      return isDeveloper ? (
        <p key={name}>
          undefined: {name},{fieldSettings[name].fieldType} - {variables[name]}
        </p>
      ) : null;
  }
};

export default FormField;
